import { mapboxgl, createMap } from './mapbox';

const canvas = document.querySelector('.map-canvas');
const loader = document.querySelector('.map-loader');
const locationContainer = document.querySelector('.map-locations');
const routeContainer = document.querySelector('.map-routes');
const filterButtons = document.querySelectorAll('.map-filter');

const defaultCategories = canvas.dataset.defaultCategories;
const defaultTags = canvas.dataset.defaultTags;
const postTypes = canvas.dataset.postTypes;

let markers = [];
let currentMarker = null;
let currentCard = null;
let currentCategories = null;
let currentTags = null;
let bounds = null;

const map = createMap({
    container: canvas,
    center: [4.8885, 52.8431],
    zoom: 10
});

// Disable map zoom on scroll, so users can scroll past the map
map.scrollZoom.disable();

// Add zoom and rotation controls to the map
map.addControl(new mapboxgl.NavigationControl());

function getBoundsOptions() {
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const padding = isMobile ? { top: 40, right: 40, bottom: 200, left: 40 } : { top: 100, right: 100, bottom: 100, left: 424 };

    return { padding };
}

function createMarkers(className = '') {
    const locations = locationContainer?.querySelectorAll('.map-location') ?? [];
    const routes = routeContainer?.querySelectorAll('.map-route') ?? [];

    if (!locations.length && !routes.length) {
        return;
    }

    bounds = new mapboxgl.LngLatBounds();
    
    locations.forEach(location => {
        const lng = parseFloat(location.dataset.lng);
        const lat = parseFloat(location.dataset.lat);
        const marker = document.createElement('div');

        marker.className = 'map-marker' + (className ? ' has-custom-icons ' + className : '');
        marker.dataset.id = location.dataset.id;
        marker.addEventListener('click', handleMarkerClick);

        markers.push(new mapboxgl.Marker(marker).setLngLat([lng, lat]).addTo(map));
        bounds.extend([lng, lat]);
    });

    routes.forEach(route => {
        const lng = parseFloat(route.dataset.lng);
        const lat = parseFloat(route.dataset.lat);
        const markerHtml = document.createElement('div');

        markerHtml.className = 'map-marker';
        markerHtml.addEventListener('click', (e) => {
            e.stopPropagation();

            new mapboxgl.Popup({
                offset: 25,
                maxWidth: '280px',
                closeOnClick: false
            })
                .setLngLat([lng, lat])
                .setHTML(route.innerHTML)
                .addTo(map);
        });

        // const popup = new mapboxgl.Popup({ offset: 25, maxWidth: '280px' })
        //     .setLngLat([lng, lat])
        //     .setHTML(route.innerHTML)
        //     .addTo(map);

        markers.push(new mapboxgl.Marker(markerHtml).setLngLat([lng, lat]).addTo(map));
        bounds.extend([lng, lat]);
    });
    
    if (markers.length > 1) {
        map.fitBounds(bounds, getBoundsOptions());
    } else {
        map.flyTo({ center: bounds.getCenter(), zoom: 14 });
    }
}

function removeMarkers() {
    markers.forEach(marker => marker.remove());
    markers = [];
}

function activateLocation(locationId) {
    const targetMarker = markers.find(marker => marker.getElement().dataset.id == locationId);
    const targetCard = locationContainer.querySelector('.map-location[data-id="' + locationId + '"]');

    if (!targetMarker || !targetCard) {
        return;
    }

    currentMarker?.getElement().classList.remove('active');
    currentCard?.classList.remove('active');

    targetMarker.getElement().classList.add('active');
    targetCard.classList.add('active');

    currentMarker = targetMarker;
    currentCard = targetCard;

    map.flyTo({
        center: [targetCard.dataset.lng, targetCard.dataset.lat],
        zoom: 14
    });

    const cardContainerHeight = locationContainer.getBoundingClientRect().height;
    const cardHeight = targetCard.getBoundingClientRect().height;

    locationContainer.scrollTo({
        top: targetCard.offsetTop - (cardContainerHeight / 2) + (cardHeight / 2),
        behavior: 'smooth'
    });
}

function deactivateLocation() {
    currentMarker?.getElement().classList.remove('active');
    currentCard?.classList.remove('active');

    currentMarker = currentCard = null;

    if (markers.length > 1) {
        map.fitBounds(bounds, getBoundsOptions());
    }
}

function handleMarkerClick(e) {
    const marker = e.target;
    
    if (currentMarker?.getElement() === marker) {
        deactivateLocation();
    } else {
        activateLocation(marker.dataset.id);
    }
}

function handleLocationContainerClick(e) {
    const isCloseButton = e.target.classList.contains('.card-close') || e.target.closest('.card-close');
    const isShowButton = e.target.classList.contains('.card-show-on-map') || e.target.closest('.card-show-on-map');
    const card = e.target.closest('.map-location');

    if (!isCloseButton && !isShowButton) {
        return;
    }

    e.stopPropagation();
    e.preventDefault();

    if (isShowButton && card !== currentCard) {
        activateLocation(card.dataset.id);
    } else if (isCloseButton || (isShowButton && card === currentCard)) {
        deactivateLocation();
    }
}

function handleFilterButtonClick(e) {
    const button = e.currentTarget;
    const wasActive = button.classList.contains('active');

    if (wasActive) {
        currentCategories = defaultCategories;
        currentTags = defaultTags;
    } else {
        currentCategories = button.dataset.categories ?? '';
        currentTags = button.dataset.tags ?? '';
    }

    filterButtons.forEach(button => button.classList.remove('active'));
    
    if (!wasActive) {
        button.classList.add('active');
    }

    fetch(urls.ajax, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: `action=filter_locations&categories=${currentCategories}&tags=${currentTags}&post_types=${postTypes}`
    }).then(response => response.text()).then(result => {
        locationContainer.innerHTML = result;
        removeMarkers();
        createMarkers(wasActive ? 'highlight' : button.dataset.markerClass);
    });
}

createMarkers('highlight');
map.on('load', () => loader.classList.add('hidden'));
locationContainer?.addEventListener('click', handleLocationContainerClick);
filterButtons.forEach(button => button.addEventListener('click', handleFilterButtonClick));